export default __webpack_public_path__ + "static/media/leaf-left.009cabf9.png";